//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"

export default {
  name: 'CommunityHome',
  components: {
  },
  data: function() {
    return {
      patterns: [],
      allPatterns: [],
      existingPatterns: []
    }
  },
  methods: {
    downloadPattern: async function(pattern) {
      pattern.is_downloading = true;

      //Get pattern data from Webcenter
      const ptData = (await axios.get("https://webcenter.sisyphus-industries.com/tracks/" + pattern.track_id + "/download.json", { headers: {Authorization: this.$root.community.authToken }})).data.resp;
      var formData = new FormData();
      var blob = new Blob([ptData], {type: "text/plain"});
      formData.append("file", blob, pattern.track_id + "-" + pattern.name.replace(/-/g, "") + ".thr");
      await axios.post(this.$root.baseURL + "/uploadtofileman", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      });
      pattern.is_downloading = false;
      pattern.is_downloaded = true;
    },
    loadMoreTracks: function(index, done) {
      let i = 0;
      this.allPatterns.forEach(pattern => {
        i++;
        if(i < 10) {
          this.allPatterns.shift();
          this.patterns.push(pattern);
        }
      })
      done()
    },
    openPlaylist: function(pname) {
      this.$router.push("/community/playlist/" + pname);
    },
    refreshFiles: async function(done) {
      if(this.$root.community.authToken == "") {
          //Log in to Webcenter
          await axios.post("https://webcenter.sisyphus-industries.com/auth_user", {
              email: this.$root.community.email, password: this.$root.community.password
          }).then((resp) => {
              this.$root.community.authToken = resp.data.resp[0].auth_token;
          });
      }

      //Get all files on bot
      await axios.get(this.$root.baseURL + "/filelist").then((response) => {
        response.data.files.forEach(file => {
          if(file.name.includes(".THR") || file.name.includes(".thr")) {
            //thr
            this.existingPatterns.push(file.name.split("-")[0]);
          }
        });
      });

      //Get popular tracks
      await axios.get("https://webcenter.sisyphus-industries.com/tracks.json?sort=most_popular", { headers: {Authorization: this.$root.community.authToken }}).then((response) => {
        const tracks = response.data.resp;
        tracks.forEach(track => {
            track.is_downloading = false
            track.is_downloaded = false
            if(this.existingPatterns.includes(track.track_id)) {
              track.is_downloaded = true
            }
            this.allPatterns.push(track)
        });
      });

      //load first ten patterns into list
      let i = 0;
      this.allPatterns.forEach(pattern => {
        i++;
        if(i < 10) {
          this.allPatterns.shift();
          this.patterns.push(pattern);
        }
      })
      done();
    }
  },
  mounted: function() {
    this.refreshFiles();
  }
}
